<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '../../composables/useI18n'
import MarkdownViewer from '../MarkdownViewer.vue'

const props = defineProps<{ open: boolean; content: string }>()
const emit = defineEmits<{ 'update:open': [value: boolean] }>()

const { t } = useI18n()

const hasContent = computed(() => !!props.content.trim())
</script>

<template>
  <a-modal
    width="min(720px, 90vw)"
    :open="open"
    :footer="null"
    :title="t('shell.account.recharge.agreementTitle')"
    class="min-h-modal"
    @cancel="emit('update:open', false)"
  >
    <!-- 协议正文可能很长，是「弹窗内容区固定滚动」的天然例外（其余弹窗禁止内部滚动） -->
    <div class="max-h-[60vh] overflow-y-auto pr-1">
      <MarkdownViewer v-if="hasContent" :markdown="content" />
      <div v-else class="py-8 text-center text-sm text-gray-400 dark:text-gray-500">
        {{ t('shell.account.recharge.agreementEmpty') }}
      </div>
    </div>
  </a-modal>
</template>
